import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { tracking } from "shared/data";
import { getAbsoluteUrl, notEmpty } from "shared/lib/utils";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { heroSecondaryArticlesHomeV2QueueItemsEdge$key } from "scmp-app/queries/__generated__/heroSecondaryArticlesHomeV2QueueItemsEdge.graphql";

import { Container, StyledContentItemHomeSecondary } from "./styles";

type Props = {
  className?: string;
  reference: heroSecondaryArticlesHomeV2QueueItemsEdge$key;
};

export const HomeV2HeroSecondaryArticles: FunctionComponent<Props> = ({ className, reference }) => {
  const items = useFragment(
    graphql`
      fragment heroSecondaryArticlesHomeV2QueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Content {
            entityId
            ...homeSecondaryV2ContentItemContent
          }
        }
      }
    `,
    reference,
  );

  if (!notEmpty(items)) return null;
  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: tracking.module.TopStory,
      }}
    >
      <Container className={className}>
        {items.map(({ node }, index) => (
          <StyledContentItemHomeSecondary
            key={node.entityId}
            onClick={(entityId, urlAlias) => {
              // Keeps the v1 homepage `top_story1` widget_name and the
              // `article_seq` numbering (the hero is "1", these follow).
              sendGA4Tracking({
                action: "click",
                category: "recirculation",
                customized_parameters: {
                  article_id: entityId,
                  article_seq: `${index + 2}`,
                  destination_url: getAbsoluteUrl(urlAlias),
                  page_type: "homepage",
                  widget_name: "top_story1",
                },
                subcategory: "widget",
              });
            }}
            reference={node}
            withComment
            withExclusiveHeaderFlag
            withLiveTag
            withSection
            withSeriesShortLabel
          />
        ))}
      </Container>
    </BaseLinkContextProvider>
  );
};

HomeV2HeroSecondaryArticles.displayName = "HomeV2HeroSecondaryArticles";
